/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import React, {useMemo, useRef} from 'react';
import classNames from 'classnames';
import Notification from "../../../models/notificationModel";
import {getProductsLabel} from "../../../util/emailStepUtil";
import {ActivateHandle} from "../../../util/interfaces";
import ProductSelectionController from "../../productSelection/productSelectionController";
import {ProductSelection} from "../../../util/types";
import {ResponseData, showDialog} from "@dvrd/dvr-controls";
import {onShowConfirmSnackbar} from "../../../util/renderUtil";
import {createErrorMessage} from "../../../util/utils";

interface Props {
    onSuccess: (notification: Notification) => void;
    notification: Notification;
    disabled: boolean;
    className?: string;
    text?: string;
}

export default function NotificationProducts(props: Props) {
    const {onSuccess, notification, disabled, className, text} = props;
    const productsRef = useRef<ActivateHandle>(null);
    const buttonLabel = useMemo(() => {
        const {productSelectionJSON, productSelection, numProducts} = notification;
        return getProductsLabel(productSelectionJSON.clauses, productSelection, numProducts);
    }, [notification.productSelectionJSON, notification.productSelection, notification.numProducts]);

    function onSubmitProductSelection(selection: ProductSelection) {
        const notif = notification.clone();
        notif.productSelectionJSON = selection;
        if (!notif.productSelectionChanged) return productsRef.current?.close!();
        notif.productSelectionJSON = selection;
        notif.update((notification: Notification, success: boolean, data: ResponseData) => {
            if (success) {
                onSuccess(notification);
                onShowConfirmSnackbar('De notificatie is bijgewerkt');
                productsRef.current?.close!();
            } else showDialog(createErrorMessage(data.message ?? 'Het bijwerken van de notificatie is niet gelukt.'),
                'Bijwerken mislukt');
        });
    }

    function onOpenProducts() {
        const selection = notification.productSelectionJSON;
        productsRef.current?.activate(selection);
    }

    return (
        <>
            <section>
                <label className='fixed-text'>{text ?? 'voor'}</label>
                <div className={classNames('var-button', disabled && 'disabled', 'products-button', className)}
                     onClick={disabled ? undefined : onOpenProducts}>
                    <label className='button-label'>{buttonLabel}</label>
                </div>
            </section>
            <ProductSelectionController loading={false} onSubmit={onSubmitProductSelection} ref={productsRef}/>
        </>
    )
}